import { useQuery } from "@tanstack/react-query";
import OrderServices from "../services/orderServices";
import { MOBILE_CONFIG_KEYS } from "../utils/constants";
import { isMobileConfigFlagEnabled } from "../utils/util";

export const useGetMobileConfig = (enabled = true) => {
  return useQuery({
    queryKey: ["GET_MOBILE_CONFIG"],
    queryFn: async () => {
      const response = await OrderServices.getMobileConfig();
      return {
        orca_shipment_refetch_cooldown_seconds:
          response.orca_shipment_refetch_cooldown_seconds,
        orca_order_refetch_cooldown_seconds:
          response.orca_order_refetch_cooldown_seconds,
        [MOBILE_CONFIG_KEYS.FF_ONE_SHIPMENT_MULTIPLE_CUSTOMER_ORDER]:
          isMobileConfigFlagEnabled(
            response?.[MOBILE_CONFIG_KEYS.FF_ONE_SHIPMENT_MULTIPLE_CUSTOMER_ORDER],
          ),
        [MOBILE_CONFIG_KEYS.FF_ENABLE_SHIPMENT_DELETION]:
          isMobileConfigFlagEnabled(
            response?.[MOBILE_CONFIG_KEYS.FF_ENABLE_SHIPMENT_DELETION],
          ),
        [MOBILE_CONFIG_KEYS.FF_MULTI_HOP_LOGISTICS]:
          isMobileConfigFlagEnabled(
            response?.[MOBILE_CONFIG_KEYS.FF_MULTI_HOP_LOGISTICS],
          ),
      };
    },
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    enabled,
  });
};
